import Constant from "@/constants/config/Constant";
export default {
  methods: {
    replaceByDefault(e) {
      e.target.src = Constant.AVATAR_IMAGE;
    },
  },
};
